<template>
    <svg height="8.723" viewBox="0 0 5.112 8.723" width="5.112" xmlns="http://www.w3.org/2000/svg">
        <path
            id="Path_2226"
            d="M4.975,4.7a.494.494,0,0,0,0-.681L1.09.136A.453.453,0,0,0,.759,0,.453.453,0,0,0,.426.136l-.29.29A.453.453,0,0,0,0,.758a.515.515,0,0,0,.136.35L3.391,4.361.136,7.615A.515.515,0,0,0,0,7.965.453.453,0,0,0,.136,8.3l.29.29a.453.453,0,0,0,.333.136.453.453,0,0,0,.331-.136Z"
            data-name="Path 2226"
            fill="#3699ff"
        />
    </svg>
</template>

<script>
export default {
    name: "RightButton",
};
</script>
